(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-slider"] && !Shopify.designMode) return;
  try {
    

  const container = document.querySelector('.slider-container');
  document.querySelector('.slider').addEventListener('input', (e) => {
    container.style.setProperty('--position', `${
      e.target.value
    }%`);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-inquiries-slider"] && !Shopify.designMode) return;
  try {
    
  $('.heirloom__slider').slick({
    slidesToShow: 3.5,
    slidesToScroll: 1,
    infinite: false,
    nextArrow: '.next-link',
    prevArrow: '.previous-link',
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-hero-slider"] && !Shopify.designMode) return;
  try {
      
const sectionBlock = $(".hero-slider-section");
const heroSlider = $(".hero-slider");
const autoplay = sectionBlock.find("#slider-autoplay")[0].value;
const autoplaySpeed = sectionBlock.find("#slider-autoplay-speed")[0].value;

heroSlider.slick({
    slidesToShow: 1,
    infinite: true,
    autoplay: autoplay,
    autoplaySpeed: autoplaySpeed,
    nextArrow: '.hero-slider_next-link',
    prevArrow: '.hero-slider_prev-link',
    arrows: true
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heirloom-slider"] && !Shopify.designMode) return;
  try {
    
  $('.heirloom__slider').slick({
    slidesToShow: 3.5,
    slidesToScroll: 1,
    infinite: false,
    nextArrow: '.next-link',
    prevArrow: '.previous-link',
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  function setCardOpen($shop, open) {
    $shop.toggleClass('is-open', open);
    $shop.find('.hero-product__cart').attr('aria-expanded', String(open));
  }

  function initHeroProduct(container) {
    $(container).find('[data-hero-product]').addBack('[data-hero-product]').each(function () {
      var $section = $(this);
      var $slider = $section.find('.hero-product__slider');

      if ($slider.hasClass('slick-initialized') || $slider.children().length < 2) {
        return;
      }

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        infinite: true,
        speed: 600,
        autoplay: $section.data('autoplay') === true,
        autoplaySpeed: $section.data('autoplay-speed'),
        prevArrow: $section.find('.hero-product__arrow--prev'),
        nextArrow: $section.find('.hero-product__arrow--next'),
        arrows: true,
        dots: false
      });

      $slider.on('beforeChange', function () {
        setCardOpen($slider.find('.hero-product__shop'), false);
      });
    });
  }

  initHeroProduct(document);

  // Hover reveals the card via CSS; click toggles it for touch and keyboard users
  $(document)
    .on('click', '.hero-product__cart', function () {
      var $shop = $(this).closest('.hero-product__shop').removeClass('is-dismissed');
      setCardOpen($shop, !$shop.hasClass('is-open'));
    })
    .on('click', '.hero-product__close', function () {
      // is-dismissed keeps the card hidden while the pointer is still over it
      var $shop = $(this).closest('.hero-product__shop').addClass('is-dismissed');
      setCardOpen($shop, false);
      $shop.find('.hero-product__cart').trigger('focus');
    })
    .on('mouseleave', '.hero-product__shop', function () {
      setCardOpen($(this).removeClass('is-dismissed'), false);
    })
    .on('focusout', '.hero-product__shop', function (event) {
      if (!this.contains(event.relatedTarget)) {
        setCardOpen($(this), false);
      }
    });

  // Theme editor support
  $(document)
    .on('shopify:section:load', function (event) {
      initHeroProduct(event.target);
    })
    .on('shopify:section:unload', function (event) {
      $(event.target).find('.hero-product__slider.slick-initialized').slick('unslick');
    })
    .on('shopify:block:select', function (event) {
      var $slide = $(event.target);
      var $slider = $slide.closest('.hero-product__slider.slick-initialized');

      if ($slider.length) {
        $slider.slick('slickPause');
        $slider.slick('slickGoTo', $slide.data('slick-index'));
      }

      setCardOpen($slide.find('.hero-product__shop'), true);
    })
    .on('shopify:block:deselect', function (event) {
      setCardOpen($(event.target).find('.hero-product__shop'), false);
    });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-custom"]) return;
  try {
    
  let customUrlField = document.querySelector('[data-custom-url-field]');
  customUrlField.value = window.location.href;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacking-header"] && !Shopify.designMode) return;
  try {
    
  const list = $('.stacking-header__list');
  const items = $('.heirloom-slider-wrapper .heading-title');

  const titleItems = $('.heirloom-slider-wrapper .heading-title');
  titleItems.each((index, item) => {
    const handle = item.textContent.trim().toLowerCase().replace(/ /g, '-');
    item.closest('.heirloom-slider-wrapper').setAttribute('id', handle);
  });

  list.find('a').on('click', function (e) {
    e.preventDefault();
    const targetId = $(this).attr('href').substring(1);
    const targetElement = $('#' + targetId);

    $('html, body').animate(
      {
        scrollTop: targetElement.offset().top - 120,
      },
      800
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-contact-form"]) return;
  try {
    
  var rellax = new Rellax('.rellax');

  if (window.innerWidth < 768) {
    rellax.destroy();
  }

  window.addEventListener("resize orientationChange", function() {
    if (window.innerWidth < 768) {
      rellax.destroy();
    } else {
      rellax.refresh();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-loose-stones"] && !Shopify.designMode) return;
  try {
    
  const categoryLinks = document.querySelectorAll('.categories-item');
  const cards = document.querySelectorAll('.items-grid__card');

  categoryLinks.forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      //add active class
      categoryLinks.forEach((catItem) => {
        catItem.classList.remove('categories-list__item--active');
      });
      element.classList.add('categories-list__item--active');

      //add active category to the sorter
      const category = element.dataset.id;
      cards.forEach((card) => {
        if (category === 'all') {
          card.classList.remove('hide');
        } else {
          card.classList.add('hide');
          if (card.classList.contains(category)) {
            card.classList.remove('hide');
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-custom-ring"]) return;
  try {
    
  let realProductUrl = Cookies.get('realProductUrl');

  if (realProductUrl.length) {
    //Cookies.remove('realProductUrl');

    let productUrlField = document.querySelector('[data-product-url-field]');

    productUrlField.value = theme.routes.root+realProductUrl;
  }

  } catch(e) { console.error(e); }
})();
})();
